import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PromoOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PromoOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.7424 22.5009C11.5887 22.5009 11.4389 22.4382 11.3302 22.3285L2.34945 13.3487C2.12424 13.1206 2.12424 12.7524 2.34651 12.5272L10.0608 4.81349C12.7637 2.10907 17.1625 2.10907 19.8655 4.81349C21.1751 6.12261 21.8962 7.86354 21.8962 9.7161C21.8962 11.5677 21.1751 13.3086 19.8655 14.6187L12.1542 22.3295C12.0597 22.4235 11.9035 22.5058 11.7424 22.5009ZM3.35504 12.9365L11.7424 21.3229L19.1566 13.9098C20.2767 12.7897 20.8936 11.2994 20.8936 9.7161C20.8936 8.13183 20.2767 6.64254 19.1566 5.52239C16.8448 3.21062 13.0834 3.21062 10.7696 5.52239L3.35504 12.9365Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0599 7.12037C17.9316 7.12037 17.8034 7.07141 17.7055 6.9735C17.5096 6.77767 17.5096 6.46042 17.7055 6.2646L21.3244 2.64565C21.5202 2.44982 21.8375 2.44982 22.0333 2.64565C22.2291 2.84148 22.2291 3.15873 22.0333 3.35455L18.4144 6.9735C18.3164 7.07142 18.1882 7.12037 18.0599 7.12037Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.5735 11.1887C11.1065 11.1887 10.6394 11.0115 10.284 10.6561C9.57362 9.94424 9.57362 8.78688 10.284 8.077C10.9944 7.36614 12.1512 7.36614 12.8626 8.077C13.573 8.78688 13.573 9.94423 12.8631 10.6561C12.5077 11.0115 12.0401 11.1887 11.5735 11.1887ZM11.5735 8.54601C11.363 8.54601 11.153 8.6263 10.9929 8.7859C10.6732 9.10609 10.6732 9.62699 10.9934 9.94717C11.3126 10.2664 11.8335 10.2664 12.1537 9.94717C12.4734 9.62698 12.4734 9.10608 12.1537 8.7859C11.9936 8.6263 11.7836 8.54601 11.5735 8.54601Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.8159 9.68575C16.3489 9.68575 15.8818 9.50852 15.5264 9.15309C14.816 8.44125 14.816 7.28389 15.5264 6.574C16.2372 5.86412 17.3941 5.86216 18.105 6.574C18.8153 7.28389 18.8153 8.44124 18.1055 9.15309C17.75 9.50852 17.2825 9.68575 16.8159 9.68575ZM16.8159 7.04301C16.6054 7.04301 16.3954 7.1233 16.2353 7.28291C15.9156 7.60309 15.9156 8.124 16.2358 8.44418C16.555 8.76338 17.0759 8.76338 17.3961 8.44418C17.7158 8.12399 17.7158 7.60308 17.3961 7.28291C17.236 7.1233 17.0259 7.04301 16.8159 7.04301Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.5735 18.6675C11.1065 18.6675 10.6394 18.4903 10.284 18.1348C9.57411 17.424 9.57411 16.2666 10.2835 15.5557C10.9954 14.8449 12.1517 14.8449 12.8626 15.5557C13.5725 16.2666 13.5725 17.424 12.8631 18.1348C12.5077 18.4903 12.0401 18.6675 11.5735 18.6675ZM11.5735 16.0248C11.363 16.0248 11.153 16.105 10.9929 16.2646C10.6737 16.5848 10.6737 17.1057 10.9934 17.4259C11.3126 17.7451 11.8335 17.7451 12.1537 17.4259C12.4729 17.1057 12.4729 16.5848 12.1532 16.2646C11.9936 16.105 11.7836 16.0248 11.5735 16.0248Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.0009 13.8168C6.74045 13.8168 6.52014 13.6151 6.50153 13.3517C6.48146 13.0746 6.68953 12.8347 6.96565 12.8151L15.6909 12.1914C15.9743 12.1581 16.2069 12.3804 16.2265 12.6555C16.2465 12.9326 16.0385 13.1725 15.7623 13.1921L7.03713 13.8158C7.02489 13.8168 7.01265 13.8168 7.0009 13.8168Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PromoOutlineIcon;
